import { JSX, useContext } from "react";
import ProjectService from "@app/projects/projectService";
import BulkProviderChangeReports from "@app/shared/BulkProviderChangeReports";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import Features from "@app/feature-flags/features";

const projectService = new ProjectService();
const ViewMyTargets = (): JSX.Element => {
  const featureFlags = useContext(FeatureFlagContext).enabledFeatureFlags;
  const isZipVolumeTargetingEnabled = featureFlags.has(Features.ZIP_CODE_ANALYSIS_VOLUME_TARGETING);
  const endpoint = () => projectService.getBulkProviderTargetExports();
  return <BulkProviderChangeReports endpoint={endpoint} title="Volume Targeting" buttonTerm="Targets" zipTargetingEnabled={isZipVolumeTargetingEnabled} />;
};

export default ViewMyTargets;
